import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

export const getDetalleProductos = async () => {
  const response = await PrivateInterceptor('Global/DetalleProductos/Productos', 'GET');
  return response;
}

export const GuardarDetalleProductos = (Datos) => {
  const respuesta = PrivateInterceptor("Global/DetalleProductos/GuardarDetalle", "POST", {Datos});
  return respuesta;
};

export const EliminarDetalleProductos = (Ids) => {
  const respuesta = PrivateInterceptor("Global/DetalleProductos/EliminarDetalles", "POST", {Ids});
  return respuesta;
};